<template><div><!--THIS FILE IS AUTOGENERATED, DONOT EDIT IT-->
<h2>dialog</h2>
<hr>
<h3>Actionsheet_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/actionsheet/metas.yml" target="_blank">编辑文档</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/actionsheet">进入demo页面</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/actionsheet" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Actionsheet.vue" target="_blank">demo源码</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Actionsheet } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>是否显示, 使用 v-model 绑定变量</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show-cancel</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>是否显示取消菜单，对安卓风格无效</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">cancel-text</span></td>
<td><span class="type type-string">String</span></td>
<td>cancel(取消)</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>取消菜单的显示文字</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">theme</span></td>
<td><span class="type type-string">String</span></td>
<td>ios</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>菜单风格，可选值为[‘ios’,‘android’]</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">menus</span></td>
<td><span class="type type-object">Object</span><br><span class="type type-array">Array</span></td>
<td>{}</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>菜单项列表，举例：<code>{menu1: '删除'}</code>，如果名字上带有<code>.noop</code>表明这是纯文本(HTML)展示，不会触发事件，用于展示描述或者提醒。<br>从<code>v2.1.0</code>开始支持数组类型的菜单，可自定义键值，见下面说明。</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">close-on-clicking-mask</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.0.0</span></td>
<td>点击遮罩时是否关闭菜单，适用于一些进入页面时需要强制选择的场景。</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">close-on-clicking-menu</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.3.8</span></td>
<td>点击菜单时是否自动隐藏</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-click-menu</span></td>
<td>(menuKey, menuItem)</td>
<td>点击菜单时触发</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-click-menu-{menuKey}</span></td>
<td>(menuKey)</td>
<td>点击事件的快捷方式, <code>menuKey</code>与<code>label</code>的值有关。举例：如果你有一个菜单名字为<code>delete</code>, 那么你可以监听 <code>on-click-menu-delete</code></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-click-menu-cancel</span></td>
<td> </td>
<td>点击取消菜单时触发</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-click-mask</span></td>
<td> </td>
<td>点击遮罩时触发</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.3.4</span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/actionsheet">Demo page</a></p>
<p>从<code>v2.1.0</code>开始支持数组类型的菜单。</p>
<p><code>label</code>: 菜单名字，支持文字及<code>html</code>。</p>
<p><code>value</code>: 英文字符，表示触发事件的名字，如果不设置不会触发<code>on-click-menu</code>事件。</p>
<p><code>type</code>: 类型，可选值如下</p>
<ul>
<li><code>primary</code> 主色</li>
<li><code>warn</code> 警告色</li>
<li><code>disabled</code> 不可操作，灰色。点击时不会关闭</li>
<li><code>info</code> 信息提示，点击时不会关闭。作用同对象类型的<code>key.noop</code>。</li>
</ul>
<pre class="hljs"><code>[{
  <span class="hljs-attr">label</span>: <span class="hljs-string">'Are you sure?&lt;br/&gt;&lt;span style="color:#666;font-size:12px;"&gt;Once deleted, you will never find it.&lt;/span&gt;'</span>,
  <span class="hljs-attr">type</span>: <span class="hljs-string">'info'</span>
}, {
  <span class="hljs-attr">label</span>: <span class="hljs-string">'Primary'</span>,
  <span class="hljs-attr">type</span>: <span class="hljs-string">'primary'</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">'primary'</span>
}, {
  <span class="hljs-attr">label</span>: <span class="hljs-string">'Warn'</span>,
  <span class="hljs-attr">type</span>: <span class="hljs-string">'warn'</span>
}, {
  <span class="hljs-attr">label</span>: <span class="hljs-string">'Disabled'</span>,
  <span class="hljs-attr">type</span>: <span class="hljs-string">'disabled'</span>
}, {
  <span class="hljs-attr">label</span>: <span class="hljs-string">'Default'</span>
}]
</code></pre>
<hr>
<h3>Alert_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/alert/metas.yml" target="_blank">编辑文档</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/alert">进入demo页面</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/alert" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Alert.vue" target="_blank">demo源码</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Alert } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p>该组件支持以<code>plugin</code>形式调用：</p>
<p class="warning">
以插件形式调用时，和`template`中使用不同，属性名请使用`小驼峰式`，比如`buttonText`而不是`button-text`。
<br>
<br>
在 `ViewBox` 或者 `overflow-scrolling:touch` 的容器中使用时，请使用 `prop:transfer-dom` 来解决其引起的 `z-index` 失效问题。详细参考 demo。
</p>
<pre class="hljs"><code><span class="hljs-keyword">import</span>  { AlertPlugin } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
Vue.use(AlertPlugin)

<span class="hljs-comment">// 或者umd方式</span>
<span class="hljs-comment">// 引入构建的js文件</span>
Vue.use(vuxAlertPlugin)
</code></pre>
<pre class="hljs"><code><span class="hljs-comment">// 显示</span>
<span class="hljs-keyword">this</span>.$vux.alert.show({
  <span class="hljs-attr">title</span>: <span class="hljs-string">'Vux is Cool'</span>,
  <span class="hljs-attr">content</span>: <span class="hljs-string">'Do you agree?'</span>,
  onShow () {
    <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'Plugin: I\'m showing'</span>)
  },
  onHide () {
    <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'Plugin: I\'m hiding'</span>)
  }
})
<span class="hljs-comment">// 隐藏</span>
<span class="hljs-keyword">this</span>.$vux.alert.hide()
</code></pre>
<p class="tip">
如果你想实现在`vue-router`的`beforeEach`或者`afterEach`的 hook 里关闭，可以使用 `Vue.$vux.alert.hide()`
</p>
<br>
<p class="tip">
该组件在 v2.7.2 以上支持单独调用，方法和插件使用一致。
</p>
<pre class="hljs"><code>import { AlertModule } from 'vux'
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>是否显示, 使用 v-model 绑定变量</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>弹窗标题</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">content</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.0</span></td>
<td>提示内容，作为 slot:default 的默认内容，如果使用 slot:default, 将会失效</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">button-text</span></td>
<td><span class="type type-string">String</span></td>
<td>ok(确定)</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>按钮文字</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">hide-on-blur</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>是否在点击遮罩时自动关闭弹窗</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">mask-transition</span></td>
<td><span class="type type-string">String</span></td>
<td>vux-fade</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>遮罩动画</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">dialog-transition</span></td>
<td><span class="type type-string">String</span></td>
<td>vux-dialog</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>弹窗主体动画</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">mask-z-index</span></td>
<td><span class="type type-number">Number</span><br><span class="type type-string">String</span></td>
<td>1000</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.6.4</span></td>
<td>遮罩层 z-index 值</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>提示内容</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-show</span></td>
<td> </td>
<td>弹窗显示时触发</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-hide</span></td>
<td> </td>
<td>弹窗关闭时触发</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/alert">Demo page</a></p>
<hr>
<h3>Confirm_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/confirm/metas.yml" target="_blank">编辑文档</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/confirm">进入demo页面</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/confirm" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Confirm.vue" target="_blank">demo源码</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Confirm } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p class="tip">
 建议参照例子使用 `v-transfer-dom` 将弹窗插入 `body` 节点下，避免组件非 body 子节点导致的各种问题。
</p>
<p>该组件支持以<code>plugin</code>形式调用：</p>
<p class="warning">
以插件形式调用时，和`template`中使用不同，属性名请使用`小驼峰式`，比如`confirmText`而不是`confirm-text`。
</p>
<pre class="hljs"><code><span class="hljs-keyword">import</span>  { ConfirmPlugin } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
Vue.use(ConfirmPlugin)
</code></pre>
<pre class="hljs"><code><span class="hljs-comment">// 显示</span>
<span class="hljs-keyword">const</span> _this = <span class="hljs-keyword">this</span> <span class="hljs-comment">// 需要注意 onCancel 和 onConfirm 的 this 指向</span>
<span class="hljs-keyword">this</span>.$vux.confirm.show({
  <span class="hljs-comment">// 组件除show外的属性</span>
  onCancel () {
    <span class="hljs-built_in">console</span>.log(<span class="hljs-keyword">this</span>) <span class="hljs-comment">// 非当前 vm</span>
    <span class="hljs-built_in">console</span>.log(_this) <span class="hljs-comment">// 当前 vm</span>
  },
  onConfirm () {}
})
<span class="hljs-comment">// 隐藏</span>
<span class="hljs-keyword">this</span>.$vux.confirm.hide()
<span class="hljs-comment">// prompt形式调用</span>
<span class="hljs-keyword">this</span>.$vux.confirm.prompt(<span class="hljs-string">'placeholder'</span>, {
  onCancel () {}
  onConfirm () {}
})
<span class="hljs-comment">// 设置输入值</span>
<span class="hljs-keyword">this</span>.$vux.confirm.setInputValue(<span class="hljs-string">'value'</span>) <span class="hljs-comment">// 注意需要在 onShow 事件中执行</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>是否显示，使用<code>v-model</code>绑定</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show-input</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.0</span></td>
<td>是否显示输入框，如果为true，slot会失效</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">placeholder</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.0</span></td>
<td>输入框的提示（仅在showInput为true的情况下有效）</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">theme</span></td>
<td><span class="type type-string">String</span></td>
<td>ios</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>弹窗风格，可以是ios或android</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">hide-on-blur</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>是否在点击遮罩时自动关闭弹窗</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">title</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>弹窗标题</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">content</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>弹窗内容，作为slot默认内容，可以是html片段，如果使用slot该字段会失效</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">confirm-text</span></td>
<td><span class="type type-string">String</span></td>
<td>确认(confirm)</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>确认按钮的显示文字</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">cancel-text</span></td>
<td><span class="type type-string">String</span></td>
<td>取消(cancel)</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>取消按钮的显示文字</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">mask-transition</span></td>
<td><span class="type type-string">String</span></td>
<td>vux-fade</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>遮罩动画</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">dialog-transition</span></td>
<td><span class="type type-string">String</span></td>
<td>vux-dialog</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>弹窗动画</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">close-on-confirm</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.0</span></td>
<td>是否在点击确认按钮时自动关闭</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">input-attrs</span></td>
<td><span class="type type-object">Object</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.7</span></td>
<td>input 属性</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">mask-z-index</span></td>
<td><span class="type type-number">Number</span><br><span class="type type-string">String</span></td>
<td>1000</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.6.4</span></td>
<td>遮罩层 z-index 值</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>弹窗主体内容</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-cancel</span></td>
<td> </td>
<td>点击取消按钮时触发</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-confirm</span></td>
<td>(value)</td>
<td>点击确定按钮时触发, 参数为prompt中输入的值</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-show</span></td>
<td> </td>
<td>弹窗出现时触发</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-hide</span></td>
<td> </td>
<td>弹窗隐藏时触发</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Methods</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">v2.6.4</span></td>
<td> </td>
<td>[feature] 支持属性 mask-z-index 设置遮罩 z-index</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">setInputValue</span></td>
<td>(value)</td>
<td>设置输入值，当 show-input 为 true 时有效</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.5</span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/confirm">Demo page</a></p>
<hr>
<h3>Loading_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/loading/metas.yml" target="_blank">编辑文档</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/loading">进入demo页面</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/loading" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Loading.vue" target="_blank">demo源码</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Loading } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p>该组件支持以<code>plugin</code>形式调用：</p>
<pre class="hljs"><code><span class="hljs-keyword">import</span>  { LoadingPlugin } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
Vue.use(LoadingPlugin)

<span class="hljs-comment">// 或者umd方式</span>
<span class="hljs-comment">// 引入构建的js文件</span>
Vue.use(vuxLoadingPlugin)
</code></pre>
<pre class="hljs"><code><span class="hljs-comment">// 显示</span>
<span class="hljs-keyword">this</span>.$vux.loading.show({
 <span class="hljs-attr">text</span>: <span class="hljs-string">'Loading'</span>
})
<span class="hljs-comment">// 隐藏</span>
<span class="hljs-keyword">this</span>.$vux.loading.hide()
</code></pre>
<p class="tip">
loading同样支持在vue外直接使用，请参照 [https://github.com/airyland/vux/blob/v2/docs/examples/loading.html](https://github.com/airyland/vux/blob/v2/docs/examples/loading.html)
</p>
<p class="tip">
从v2.7.8版本开始以组件形式调用增加`delay`参数，从而实现延时显示.
</p>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>显示状态，在 v2.5.7 前使用<code>v-model</code>绑定，后面直接使用 <code>:show</code> 绑定</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">text</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>提示文字</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">position</span></td>
<td><span class="type type-string">String</span></td>
<td>fixed</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>定位方式，默认为<code>fixed</code>，在100%的布局下用<code>absolute</code>可以避免抖动</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">transition</span></td>
<td><span class="type type-string">String</span></td>
<td>vux-mask</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>显示动画名字</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>提示文字区域</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/loading">Demo page</a></p>
<hr>
<h3>Popup_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/popup/metas.yml" target="_blank">编辑文档</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/popup">进入demo页面</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/popup" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Popup.vue" target="_blank">demo源码</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Popup } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>是否关闭，使用<code>v-model</code>绑定</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">height</span></td>
<td><span class="type type-string">String</span></td>
<td>auto</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>高度，设置<code>100%</code>为整屏高度。当 position 为 top 或者 bottom 时有效。</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">hide-on-blur</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>点击遮罩时是否自动关闭</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">is-transparent</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.1.1-rc.9</span></td>
<td>是否为透明背景</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">width</span></td>
<td><span class="type type-string">String</span></td>
<td>auto</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.1-rc.6</span></td>
<td>设置 100% 宽度必须使用该属性。在 position 为 left 或者 right 时有效。</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">position</span></td>
<td><span class="type type-string">String</span></td>
<td>bottom</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.1-rc.6</span></td>
<td>位置，可取值 [‘left’, ‘right’, ‘top’, ‘bottom’]</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show-mask</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.1-rc.6</span></td>
<td>是否显示遮罩</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">popup-style</span></td>
<td><span class="type type-object">Object</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.2</span></td>
<td>弹窗样式，可以用于强制指定 z-index</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">hide-on-deactivated</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.5.5</span></td>
<td>是否在 deactived 事件触发时自动关闭，避免在路由切换时依然显示弹窗</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>弹窗主体内容</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-hide</span></td>
<td> </td>
<td>关闭时触发</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-show</span></td>
<td> </td>
<td>显示时触发</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-first-show</span></td>
<td> </td>
<td>第一次显示时触发，可以在该事件回调里初始化数据或者界面</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/popup">Demo page</a></p>
<hr>
<h3>Toast_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/toast/metas.yml" target="_blank">编辑文档</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/toast">进入demo页面</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/toast" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/Toast.vue" target="_blank">demo源码</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Toast } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p>该组件支持以<code>plugin</code>形式调用：</p>
<p class="warning">
 以插件形式调用时，和`template`中使用不同，属性名请使用`小驼峰式`，比如`isShowMask`而不是`is-show-mask`。
 </p>
<pre class="hljs"><code><span class="hljs-keyword">import</span>  { ToastPlugin } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
Vue.use(ToastPlugin)

<span class="hljs-comment">// 或者umd方式</span>
<span class="hljs-comment">// 引入构建的js文件</span>
Vue.use(vuxToastPlugin)

<span class="hljs-comment">// 默认参数</span>
Vue.use(ToastPlugin, {<span class="hljs-attr">position</span>: <span class="hljs-string">'top'</span>})
</code></pre>
<pre class="hljs"><code><span class="hljs-comment">// 显示</span>
<span class="hljs-keyword">this</span>.$vux.toast.show({
 <span class="hljs-attr">text</span>: <span class="hljs-string">'Loading'</span>
})

<span class="hljs-comment">// 显示文字</span>
<span class="hljs-keyword">this</span>.$vux.toast.text(<span class="hljs-string">'hello'</span>, <span class="hljs-string">'top'</span>)

<span class="hljs-comment">// 隐藏</span>
<span class="hljs-keyword">this</span>.$vux.toast.hide()
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">value</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>是否显示, 使用 v-model 绑定</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">time</span></td>
<td><span class="type type-number">Number</span></td>
<td>2000</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>显示时间</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">type</span></td>
<td><span class="type type-string">String</span></td>
<td>success</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>类型，可选值 success, warn, cancel, text</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">width</span></td>
<td><span class="type type-string">String</span></td>
<td>7.6em</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>宽度</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">is-show-mask</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>是否显示遮罩，如果显示，用户将不能点击页面上其他元素</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">text</span></td>
<td><span class="type type-string">String</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>提示内容，支持 html，和默认slot同样功能</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">position</span></td>
<td><span class="type type-string">String</span></td>
<td>default</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.1.1-rc.4</span></td>
<td>显示位置，可选值 default, top, middle, bottom</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>默认slot, 提示内容</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-show</span></td>
<td> </td>
<td>提示弹出时触发</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-hide</span></td>
<td> </td>
<td>提示隐藏时触发</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/toast">Demo page</a></p>
<hr>
<h3>XDialog_COM</h3>
<p><span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/components/x-dialog/metas.yml" target="_blank">编辑文档</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="#" router-link="/zh-CN/demos/x-dialog">进入demo页面</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://vux.li/demos/v2/#/component/x-dialog" target="_blank">demo 原始链接</a></span><br>
  <span style="color: #999;font-size:12px;"><a href="https://github.com/airyland/vux/blob/v2/src/demos/XDialog.vue" target="_blank">demo源码</a></span></p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { XDialog } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p class="warning">
如果当前组件所在位置某一父级使用了 `ViewBox` 组件或者直接使用了 Safari 的 `overflowScrolling:touch`，请引入指令 `transfer-dom` 以解决其带来的 `z-index` 失效问题。
<br>
<br>
如果你没有使用，那么不需要参照 demo 加上`v-transfer-dom`
</p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { TransferDomDirective <span class="hljs-keyword">as</span> TransferDom } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>

<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">directives</span>: {
    TransferDom
  }
}
</code></pre>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">v-transfer-dom</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">x-dialog</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">x-dialog</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
</code></pre>
<p class="warning">
`scroll` 属性已经在 v2.5.12 废弃，因为它并没有实现阻止 body 滚动。
<br>
如果你是 `100%` 布局，按照下面配置布局可以实现阻止滚动。
</p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { ConfigPlugin } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>

Vue.use(ConfigPlugin, {
  <span class="hljs-attr">$layout</span>: <span class="hljs-string">'VIEW_BOX'</span>
})
</code></pre>
<p><span class="vux-props-title">Props</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>version</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">show</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>弹窗是否可见，使用 <code>v-model</code> 绑定，在 v2.5.3 之后版本支持.sync修饰符</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">mask-transition</span></td>
<td><span class="type type-string">String</span></td>
<td>vux-mask</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>遮罩层动画</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">dialog-transition</span></td>
<td><span class="type type-string">String</span></td>
<td>vux-dialog</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>弹窗动画</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">hide-on-blur</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>false</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>是否在点击遮罩时自动关闭弹窗</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">scroll</span></td>
<td><span class="type type-boolean">Boolean</span></td>
<td>true</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
<td>【废弃】是否在弹窗上滚动时 body 内容也滚动</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">dialog-style</span></td>
<td><span class="type type-object">Object</span></td>
<td></td>
<td><span style="font-size:12px;white-space:nowrap;">v2.2.2</span></td>
<td>设置内部弹窗样式，覆盖原有的宽度、背景颜色等样式</td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">mask-z-index</span></td>
<td><span class="type type-number">Number</span><br><span class="type type-string">String</span></td>
<td>1000</td>
<td><span style="font-size:12px;white-space:nowrap;">v2.6.4</span></td>
<td>遮罩层 z-index 值</td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Slots</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">default</span></td>
<td>弹窗的主体内容</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><span class="vux-props-title">Events</span></p>
<table>
<thead>
<tr>
<th>name</th>
<th>params</th>
<th>description</th>
<th>version</th>
</tr>
</thead>
<tbody>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-show</span></td>
<td> </td>
<td>弹窗可见时触发</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
<tr>
<td><span class="prop-key" style="white-space:nowrap;">on-hide</span></td>
<td> </td>
<td>弹窗关闭时触发</td>
<td><span style="font-size:12px;white-space:nowrap;"></span></td>
</tr>
</tbody>
</table>
<p><a class="vux-demo-link" href="#" router-link="/zh-CN/demos/x-dialog">Demo page</a></p>
</div></template><script>
export default {
  head: {"title":" | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// components_dialog-38.vue?645c3266